export default {
    setNativeBridge(state, nativeBridge) {
        state.nativeBridge = nativeBridge
    },
    
}